export const apiUrl = ({ url = '' } = {}) => (process.env.NODE_ENV === 'production' ? window.apiUrl : process.env.REACT_APP_API_URL) + url

export const apiResource = ({ url = '' } = {}) => (process.env.NODE_ENV === 'production' ? window.pathUrlAssets : process.env.REACT_APP_RESOURCES_URL) + url

export const appUrl = ({ url = '' } = {}) => (process.env.NODE_ENV === 'production' ? window.pathFolder : process.env.REACT_APP_FOLDER_PATH) + url

export const sessionName = () => process.env.NODE_ENV === 'production' ? window.pathSessionName : process.env.REACT_APP_SESSION_NAME

export const companyName = () => process.env.NODE_ENV === 'production' ? window.pathCompanyName : process.env.REACT_APP_COMPANY_NAME